export enum ToastContextEnum {
  Success = 'success',
  Error = 'error'
}

export type ToastContext =
  ToastContextEnum.Success |
  ToastContextEnum.Error;

export interface IToast {
  id: number;
  message: string;
  context: ToastContext;
}


